import i18next from "i18next";
import React, { Suspense } from "react";
import { useDispatch } from "react-redux";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { retailerRoute, userRoute } from "./Route";
import { useInjectReducer, useInjectSaga } from "./utils/redux-injectors";

import { AuthRepoSaga } from "./pages/Auth/redux/saga";
import { actions, reducer, sliceKey } from "./pages/Auth/redux/slice";
import { actions as cartActions } from "./pages/Products/Cart/redux/slice";

import { profileRepoSaga } from "./pages/Profile/redux/saga";
import {
  reducer as profileReducer,
  sliceKey as profileSliceKey,
} from "./pages/Profile/redux/slice";
import { Is_Retailer, APP_LANGUAGE } from "./utils/Api";

function App() {
  useInjectReducer({
    key: sliceKey,
    reducer: reducer,
  });
  useInjectSaga({ key: sliceKey, saga: AuthRepoSaga });
  useInjectReducer({
    key: profileSliceKey,
    reducer: profileReducer,
  });
  useInjectSaga({ key: profileSliceKey, saga: profileRepoSaga });

  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  React.useEffect(() => {
    if (token) {
      dispatch(
        actions.doGetProfile({
          token: token || "",
          callback: () => {
            dispatch(
              cartActions.doGetCartList({
                data: {},
              })
            );
          },
        })
      );
    }

    return () => {};
  }, [token]);
  React.useEffect(() => {
    localStorage.setItem("i18nextLng", APP_LANGUAGE || "en");
    i18next.changeLanguage(APP_LANGUAGE || "en");
  }, []);

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <RouterProvider
          router={Is_Retailer === "true" ? retailerRoute : userRoute}
        />
      </Suspense>
    </>
  );
}

export default App;
